import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import {memberDetailsCommunicationHistoryCallLogWidget as MemberDetailsCommunicationHistoryCallLogWidgetView  } from 'ui/views/widgets/memberDetailsCommunicationHistoryCallLogWidget';
import { MemberDetailsCommunicationHistoryCallLogWidgetService } from 'services/memberDetailsCommunicationHistoryCallLogWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import queryString from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsCommunicationHistoryCallLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryCallLogWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryCallLogWidget propName='propValue'/>
 */
class _MemberDetailsCommunicationHistoryCallLogWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // Member Detail instance
        this.memberDetailsCommunicationHistoryCallLogWidgetService = new MemberDetailsCommunicationHistoryCallLogWidgetService();

        // start member detail data fetch
        this.memberDetailsCommunicationHistoryCallLogWidgetData();
    }

    async memberDetailsCommunicationHistoryCallLogWidgetData() {
       
        log.debug( 'MemberDetailsCommunicationHistoryCallLogWidgetService.memberDetailsCommunicationHistoryCallLogWidgetData()' );

        // cancel ongoing request
        this.memberDetailsCommunicationHistoryCallLogWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsCommunicationHistoryCallLogWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', /*value = {},*/ item = {} } = {} ) {
        log.debug( 'MemberDetailsCommunicationHistoryCallLogWidgetData.handleActionClick()' ); // @TODO: remove

        if( 'column' === type ) {
            this.props.history.push( { pathname: DASHBOARD_SUB_ROUTES.CALL_DETAIL, search: queryString.stringify( {
                callId: item.id,
            }  ) } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsCommunicationHistoryCallLogWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsCommunicationHistoryCallLogWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsCommunicationHistoryCallLogWidget.displayName = 'MemberDetailsCommunicationHistoryCallLogWidget';

// set default props
_MemberDetailsCommunicationHistoryCallLogWidget.defaultProps = {
    requestPayload: {},
};

// prop types
_MemberDetailsCommunicationHistoryCallLogWidget.propTypes = {};

export const MemberDetailsCommunicationHistoryCallLogWidget = withRouter( _MemberDetailsCommunicationHistoryCallLogWidget );
